import { render, staticRenderFns } from "./addressModal.vue?vue&type=template&id=edaceb0e&scoped=true"
import script from "./addressModal.vue?vue&type=script&lang=js"
export * from "./addressModal.vue?vue&type=script&lang=js"
import style0 from "./addressModal.vue?vue&type=style&index=0&id=edaceb0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edaceb0e",
  null
  
)

export default component.exports